import { makeStyles } from "@material-ui/core/styles";

import red from "@material-ui/core/colors/red";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: theme.typography.pxToRem(22),
    marginBlockEnd: 26,
  },
  membership: {
    fontWeight: 500,
    color: "#000",
    marginBlockEnd: 12,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    padding: "15px 27px",
    background: "#FAFBFC",
    marginBottom: 20,
    display: "flex",
    flexFlow: "column nowrap",
  },
  errorMessage: {
    color: red[500],
  },
  subtotal: ({ coupon }: { coupon: boolean }) => ({
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    fontFamily: "Lato",
    fontWeight: 500,
    borderBottom: coupon ? "none" : "2px solid #010101",
    padding: coupon ? "17px 0px 0px 0px" : "17px 0px",
    "& label": {
      color: "#000",
    },
  }),
  cuponDiscount: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    fontFamily: "Lato",
    fontWeight: 500,
    borderBottom: "2px solid #010101",
    margin: "17px 0px",
    padding: "17px 0px",
    "& label": {
      color: "#00A3A3",
    },
  },
  total: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    padding: "17px 0px 0px",
    "& label": {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      color: "#000",
      fontFamily: "Inter",
    },
  },
  sum: {
    marginBottom: 0,
    marginTop: 5,
    "& label": {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  cupon: {
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "flrx-start",
    "& .MuiTypography-root": {
      cursor: "pointer",
      fontSize: theme.typography.pxToRem(14),
      color: "#0344DC",
      marginBlockStart: 21,
      alignSelf: "flex-start",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#CF1B1B",
    },
    "& .PrivateNotchedOutline-root": {
      top: "0px",
    },
  },
  errorText: {
    fontSize: theme.typography.pxToRem(14),
    fontFamily: "Lato",
    fontWeight: 400,
    color: "#CF1B1B",
  },
  iconError: {
    "& path": {
      fill: "#CF1B1B",
    },
  },
  promotionCode: {
    marginBlockStart: 20,
  },
  buttonPay: {
    alignSelf: "center",
    padding: "8px 24px 8px 24px",
    color: "white",
    backgroundColor: "#0344DC",
    borderRadius: "100px",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    margin: "27px auto",
    "&:hover": {
      backgroundColor: "#022984",
      color: "white",
    },
    "& svg path": {
      fill: "#22D9BB",
    },
  },
  policy: {
    width: "79%",
    justifyContent: "center",
    margin: "0 auto",
    alignItems: "center",
    alignContent: "center",
    textAlign: "justify",
    color: "#747F9D",
    "& .MuiTypography-root": {
      fontWeight: 400,
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(12),
    },
    "& u": {
      color: "#0344DC",
      cursor: "pointer",
      textDecoration: "none",
    },
    "& u a": {
      color: "#0344DC",
      cursor: "pointer",
      textDecoration: "none",
    },
    "& p": {
      marginBlockEnd: "1.5rem",
    },
    "& p span:nth-last-child(-n+1)": {
      color: "#065F46",
    },
    "& svg": {
      marginInlineEnd: 5,
      marginBlockEnd: -3,
    },
    "& button": {
      padding: 0,
      margin: "0px auto 0px",
    },
    "& button span": {
      color: "#0344DC!important",
      fontWeight: 400,
      fontFamily: "Lato",
      fontSize: theme.typography.pxToRem(12),
      padding: 0,
    },
    "& .MuiButton-root:hover": {
      color: "#0344DC",
      backgroundColor: "transparent",
    },
  },
  legend: {
    "& .MuiTypography-root": {
      color: "#747F9D",
      fontSize: theme.typography.pxToRem(12),
      fontFamily: "Lato",
    },
  },
  labelColor: {
    color: "#000",
  },
  arrowRight: {
    transform: "rotate(180deg)",
    height: 14,
  },
  iconDownChevron: {
    marginInlineStart: 8,
    verticalAlign: "middle",
    position: "relative",
    height: 14,
    width: 14,
    left: 0,
    top: 0,
    "& path": {
      fill: "#0344DC",
    },
  },
  radioButton: {
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#1F2B5A",
    },
    "& .MuiRadio-colorSecondary.Mui-checked:hover": {
      background: "#E2E8F0",
    },
  },
  iconLock: {
    width: "1rem",
    height: "1rem",
  },
}));
